// Liens internes (bouton « Lien interne » de l'éditeur) : liste des cours et analyses du site,
// et adresse actuelle de chacun (un lien reste valable si le contenu est renommé).
import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "./api";
import { COURSE_TYPE_LABEL } from "./courseMeta";
import { categoryLabel } from "./articleCategories";

/**
 * Renvoie { targets, hrefs } :
 * - targets : [{ key: "course:id" | "article:id", title, href, kind, sub }] pour l'éditeur ;
 * - hrefs : { "course:id": "/cours/slug", "article:id": "/articles/slug" } pour les pages de lecture.
 */
export function useInternalLinks() {
  const coursesQ = useQuery({ queryKey: ["courses", "all"], queryFn: async () => (await api.get("/courses")).data });
  const articlesQ = useQuery({ queryKey: ["articles", "all"], queryFn: async () => (await api.get("/articles")).data });

  return useMemo(() => {
    const targets = [
      ...(coursesQ.data || [])
        .filter((c) => c.published !== false && ["concept", "article", "vocabulary"].includes(c.category))
        .map((c) => ({
          key: `course:${c.id}`,
          title: c.title,
          href: `/cours/${c.slug}`,
          kind: "course",
          sub: COURSE_TYPE_LABEL[c.category] + (c.period ? ` · ${c.period}` : ""),
        })),
      ...(articlesQ.data || []).map((a) => ({
        key: `article:${a.id}`,
        title: a.title,
        href: `/articles/${a.slug}`,
        kind: "article",
        sub: `Analyse · ${categoryLabel(a.category)}`,
      })),
    ];
    return { targets, hrefs: Object.fromEntries(targets.map((t) => [t.key, t.href])) };
  }, [coursesQ.data, articlesQ.data]);
}
